<template>
  <div>
    <div v-for="expense in groupedExpenses" v-bind:key="expense.id">
      <div class="row expense-item">
        <Expense class="col" v-bind:expense="expense" v-bind:editable="editable" v-bind:childs="childsExpenses[expense.id]"></Expense>
        <div class="actions">
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-dark" v-on:click="editExpense(expense)">
              <font-awesome-icon icon="pencil-alt"/>
            </button>
            <button type="button" class="btn btn-dark" v-on:click="delExpense(expense)">
              <font-awesome-icon icon="trash-alt"/>
            </button>
          </div>
        </div>
      </div>

      <div class="row expense-item child" v-for="child in childsExpenses[expense.id]" v-bind:key="child.id">
        <Expense class="col" v-bind:expense="child" v-bind:editable="editable" v-touch:swipe="swipeHandler"></Expense>

        <div class="actions">
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-dark" v-on:click="editExpense(child)">
              <font-awesome-icon icon="pencil-alt"/>
            </button>
            <button type="button" class="btn btn-dark" v-on:click="delExpense(child)">
              <font-awesome-icon icon="trash-alt"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <ModalQuestion ref="question"></ModalQuestion>
    <ExpenseEdit ref="expense"></ExpenseEdit>
  </div>
</template>

<script>
export default {
  props: ["expenses", "editable"],
  computed: {
    groupedExpenses() {
      return this.expenses.filter(item => !item.parent);
    },
    childsExpenses() {
      return this.expenses
      .filter(item => !!item.parent)
      .reduce((acc, curr) => {
        acc[curr.parent] = acc[curr.parent] || [];
        acc[curr.parent].push(curr);
        return acc;
      }, {});
    }
  },
  methods: {
    refresh() {
      this.$emit('refresh', this.expenses);
    },
    addExpense(newExpense) {
      let expense = newExpense || this.$piggyBank.data.newExpense();

      this.$refs.expense
        .show(expense, this.expenses)
        .then(result => {
          this.expenses.push(result);
        })
        .catch(() => {})
        .finally(this.refresh);
    },
    editExpense(expense) {
      this.$refs.expense
        .show(expense, this.expenses)
        .then(result => {
          let index = this.expenses.indexOf(expense);
          this.expenses[index] = result;
        })
        .catch(() => {})
        .finally(this.refresh); 
    },
    delExpense(expense) {
      this.$refs.question
        .ask("Czy usunąć wydatki")
        .then(() => {
          let index = this.expenses.indexOf(expense);
          this.expenses.splice(index, 1);
        })
        .catch(() => {})
        .finally(this.refresh);
    },
    swipeHandler(event) {
      console.log(arguments);
    }
  }
};
</script>

<style lang="scss" scoped>
.expense-item {
    background: #0003;
    // background: red;
    // justify-items: center;
    margin: 2px 0px;
    padding: 2px;
    border-radius: 5px;
    // border-top: 1px solid gray;
    display: flex;
    justify-content: center;
    align-items: center;

    &.child {
     background: #0001;
    }

  .mobile & {
    .actions {
      display: none;
    }
  }
}
</style>